import { environment } from '../environments/environment'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '../services/request.service';
import { Router, ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(
    private http: HttpClient,
    private request : RequestService,
    private router : Router
    ) { }

  getDepartmentInfo( departmentId:number) {
    //alert("ID : "+empId+"-> "+environment.apiBaseUrl);
    // alert(this.http.post<any>(environment.apiBaseUrl + '/hrms/view_employee/', {
    //   headers: headers,
    //   params: {
    //     'employeeId': empId,
    //   }
    // }));
    const assets = {
      'departmentId': departmentId
    };
    // const save: any = await this.request.post('/acDcCharger', charger);

    return this.request.post(environment.apiBaseUrl + '/aims/view-department/',departmentId);

    // return this.http.post<any>(environment.apiBaseUrl + '/hrms/view_employee/', {
    //   headers: headers,
    //   params: {
    //     'employeeId': empId
    //   }
    // });
  }

  customUrl="";
  getSidebarSubModuleAction( url:string) {
    // console.log("Master : "+url);
    this.customUrl = url;
    // Master : /form/route-stop-master-add/22
    // console.log(">> subModule "+localStorage.getItem("subModule"));
    if(Number(localStorage.getItem("subModule"))!=2){
      return this.SubModuleAction(url);
    }
    
  }

  SubModuleAction(url){
    let actionMap = new Map();
    let authorize = false;
    let actionAssign;
    let subModuleSession = JSON.parse(localStorage.getItem("subModule"));
    // console.log(subModuleSession);
    let currentUrl = url.split("/form/");
    for (let objKey of Object.keys(subModuleSession)) {
      // console.log(currentUrl[1]+ " :: " +subModuleSession[objKey].path);
      if(currentUrl[1]==subModuleSession[objKey].path){
        // console.log(subModuleSession[objKey].action);
        actionAssign = subModuleSession[objKey].action;
        authorize = true;
      }
    }
    if(authorize==false){
      let splitStr = this.customUrl.split("/");
      // console.log(" >> "+splitStr[0]+" :: "+splitStr[1]+" :: "+splitStr[2]);
      if(splitStr[2] == "route-stop-master-add"){

      }else{
        this.router.navigate(['/dashboard/dashboard']);
      }
    }else{
      for (let [key,val] of Object.entries(actionAssign)) {
        // console.log(key+ " :: "+val);
        if(val=="add"){
          actionMap.set("add",val);
        } else if(val=="view"){
          actionMap.set("view",val);
        }else if(val=="delete"){
          actionMap.set("delete",val);
        }else if(val=="update"){
          actionMap.set("update",val);
        }
      }
      return actionMap;
    }
  }

  getIPAddress() {  
    return this.http.get("https://api.ipify.org/?format=json");  
  } 

}
